import React from 'react';
import { useFormContext, FieldError } from 'react-hook-form';
import { Input } from '../ui/input';
import type { Form } from '../../interfaces/form.interface';
import type { Metadata } from '../../interfaces/metadata.interface';
import { BaseField } from './BaseField';

interface EmailFieldProps {
  meta: Metadata;
  index: number;
  configuration: Form;
}

export const EmailField: React.FC<EmailFieldProps> = ({
  meta,
  index,
  configuration
}) => {
  const { register, formState: { errors } } = useFormContext();
  const error = errors[meta.id] as FieldError | undefined;

  return (
    <BaseField
      meta={meta}
      index={index}
      error={error}
      configuration={configuration}
    >
      <Input
        id={meta.id}
        type="email"
        placeholder={meta.description}
        {...register(meta.id)}
        className={error ? 'border-red-500' : ''}
      />
    </BaseField>
  );
}; 